import { createSlice } from '@reduxjs/toolkit';

import { UatraitsState } from '../../../../../types/common';

const uaSlice = createSlice({
    name: 'ua',
    initialState: {} as UatraitsState,
    reducers: {},
});

export const uatraitsReducer = uaSlice.reducer;
